(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ux-header-help"] && !Shopify.designMode) return;
  try {
    class HelpLightbox extends HTMLElement {
    connectedCallback() {
      const button = this.previousElementSibling;

      button?.addEventListener('click', () => this.setAttribute('open', ''));
      this.addEventListener('click', (e) => {
        if (!e.target.closest('.header-help-lightbox__content')) {
          this.removeAttribute('open');
        }
      });

      const chatBtn = this.querySelector('[data-open-chat]');
      chatBtn?.addEventListener('click', () => {
        this.removeAttribute('open');
        window.BrevoConversations?.('openChat', true);
      });
    }
  }

  customElements.define('help-lightbox', HelpLightbox);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ux-product-media-gallery"] && !Shopify.designMode) return;
  try {
    class VideoHighlight extends HTMLElement {
    connectedCallback() {
      this._lightbox = this.querySelector('[data-lightbox]');
      this._preview = this.querySelector('[data-preview]');
      this._video = this.querySelector('[data-video]');

      this.querySelector('[data-trigger]')?.addEventListener('click', () => this.open());
      this.querySelector('[data-backdrop]')?.addEventListener('click', () => this.close());
      this.querySelector('[data-close]')?.addEventListener('click', () => this.close());

      this._onKeydown = (e) => {
        if (e.key === 'Escape') this.close();
      };
    }

    open() {
      if (!this._lightbox) return;
      this._lightbox.classList.add('is-open');
      this._lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', this._onKeydown);
      this._preview?.pause();
      this._video?.play().catch(() => {});
    }

    close() {
      if (!this._lightbox?.classList.contains('is-open')) return;
      this._lightbox.classList.remove('is-open');
      this._lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', this._onKeydown);
      this._video?.pause();
      if (this._video) this._video.currentTime = 0;
      this._preview?.play().catch(() => {});
    }
  }

  customElements.define('video-highlight', VideoHighlight);
  } catch(e) { console.error(e); }
})();

})();
